import { render, staticRenderFns } from "./WBtnPrevious.vue?vue&type=template&id=4e61b8f4&scoped=true&"
import script from "./WBtnPrevious.vue?vue&type=script&lang=js&"
export * from "./WBtnPrevious.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61b8f4",
  null
  
)

export default component.exports